import { useState } from "react";
import styled from "styled-components";
import { useAppStore } from "@/stores/appStore";
import { type_d, type_c } from "@/theme/typography";

export default function PresetGroup({ items, stateType, stateKey, defaultVal, id }) {
	const [active, seActive] = useState(defaultVal);

	const updateState = (value, stateType, stateKey, id) => {
		const state = (prevState) => ({
			...prevState.configurator,
			[stateKey]: {
				...prevState.configurator[stateKey],
				[stateType]: {
					...prevState.configurator[stateKey][stateType],
					[id]: value,
				},
			},
		});

		seActive(value);

		useAppStore.setState((prevState) => ({
			configurator: state(prevState),
		}));
	};

	return (
		<ShapeWrapper>
			{items &&
				items.map((item, i) => (
					<div
						key={i}
						onClick={() => updateState(item, stateType, stateKey, id)}
						className={`shape__item ${active == item && "is_active"}`}>
						{item.icon && item.icon()}
						<p className="shape__item__title" style={type_c}>
							{item}cm
						</p>
					</div>
				))}
		</ShapeWrapper>
	);
}

const ShapeWrapper = styled.div`
	display: grid;
	grid-template-columns: repeat(4, minMax(0, 1fr));
	row-gap: 0.5rem;
	column-gap: 8px;

	& > * {
		width: 100%;
		background: #d5ccc8;
		padding-inline: 16px;
		padding-block: 0.8rem;
		border-radius: 5px;
	}

	.shape__item {
		display: flex;
		align-items: center;
        justify-content: center;
		column-gap: 1rem;
		transition: background-color 98ms linear;
		cursor: pointer;

		svg {
			width: 20px;
			fill: #7d6a64;
		}
	}

	.shape__item:hover {
		background-color: ${({ theme }) => theme.colors.secondary};
		color: #ffe6dc;
		transition: color 98ms linear;

		svg {
			fill: #ffe6dc;
		}

		.shape__item__title {
			color: #ffe6dc;
		}
	}

	.shape__item.is_active {
		background-color: ${({ theme }) => theme.colors.secondary};
		svg {
			fill: #ffe6dc;
		}
	}

	.shape__item__title {
		font-weight: 400;
		color: #7d6a64;
	}

	.shape__item.is_active .shape__item__title {
		font-weight: 400;
		color: #ffe6dc;
	}

	.shape__item svg.icon__x-mark {
		width: 15px;
	}
`;
